import { Checkbox, FormControlLabel } from "@mui/material";
import { CustomAutocomplete } from "_components/CustomAutocomplete";
import { AutoRefreshToogle } from "_components/buttons";
import { getIcons } from "_helpers";
import { eventsActions, filterActions, mapActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { MultiSelectAutocomplete } from "_components";

export { SettingsDatas };

function SettingsDatas() {

    const dispatch = useDispatch();
    const filters = useSelector(state => state.filters?.list);
    const filterValues = useSelector(state => state.filters.values);
    const lastPositions = useSelector(state => state.map?.lastPositions?.value?.features);
    const layerVisibility = useSelector(state => state.map.layerVisibility);
    const autoRefresh = useSelector(state => state.events.autoRefresh);

    const [ filterOptions, setFilterOptions ] = useState([]);
    const [ vinList, setVinList ] = useState([]);
    const [ fleetList, setFleetList ] = useState([]);

    const [ filterSelected, setFilterSelected ] = useState(null); 
    const [ vinSelected, setVinSelected ] = useState([]); 
    const [ fleetSelected, setFleetSelected ] = useState(null);  

    const [ intervalId, setIntervalId ] = useState(null);

    const layersList = [
        {
            "subTitle": "données",
            "layers": [
                {"id": "buses", "label": "Bus (hors alertes et stops)", "checked": false },
                {"id": "routes", "label": "Trajets", "checked": false },
            ]
        },
        {
            "subTitle": "poi",
            "layers": [
                {"id": "depots", "label": "Dépôts", "checked": false },
                {"id": "dealerships", "label": "Concessionnaires", "checked": false },
                {"id": "pantographs", "label": "Pantographes", "checked": false }
            ]
        }
    ];
    
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        vin: Yup.string(),
        fleet: Yup.string(),
        filters: Yup.string(), 
    });

    const formOptions = { resolver: yupResolver(validationSchema) };
    const { reset } = useForm(formOptions);

    /*Initialisation des filtres */
    useEffect(() => {
        dispatch(filterActions.getAllFilters());
        if(!filterValues){
            dispatch(filterActions.getFilterValues())
        }
    }, []);

    /* Modification du format de filtre pour le champ autocomplete */
    useEffect(() => {
        if (filters){
            const values = Object.entries(filters).map(([key, value]) => {
                return {label: value.name, id: value.id};
            });
            setFilterOptions(values);
        }
    }, [filters])

    /* Récupération de la liste des vins */
    useEffect(() => {
        if(lastPositions && vinList.length === 0) {
            const list = lastPositions.map(feature => feature.properties.HEADER_VIN);
            setVinList(list)
        }
    }, [lastPositions])

    /* Récupération de la liste des flottes */
    useEffect(() => {
        if(filterValues) {
            setFleetList(filterValues.METROPOLIS)
        }
    }, [filterValues])

    /* Evénements sur les couches de données */
    const handleLayerVisibilityChange = (layerId) => {
        const newVisibility = !layerVisibility[layerId];
        dispatch(mapActions.setLayerVisibility({ layerId, visibility: newVisibility }));
    };

    const handleFilterChange = (newFilter) => {
        setFilterSelected(newFilter);
        setVinSelected([]);
        setFleetSelected(null);
        reset({ fleet: '' , vin: ''});

        const filterToSet = filters[newFilter]
        if (filterToSet){
            dispatch(filterActions.setFilter(filterToSet))
        }
        
        applyFilter(newFilter);
    };

    const handleVINChange = (vin) => {
        setVinSelected(vin);
        setFleetSelected(null);
        setFilterSelected(null)
        //reset({ fleet: '' , filters: ''});
        //applyFilter(null, vin);
    }

    const handleVinSearch = () => {
        applyFilter(null, vinSelected)
    }

    const handleFleetChange = (fleet) => {
        setFleetSelected(fleet);
        setVinSelected([]);
        setFilterSelected(null)
        reset({ vin: '', filters: ''});
        applyFilter(null, null, fleet);
    }

    /* Réinitialisation des champs */
    const resetFilter= () => {
        dispatch(filterActions.clearFilter());
        setFilterSelected(null)
        applyFilter();
    }
    const resetVin= () => {
        setVinList([])
        setVinSelected([]);
        applyFilter();
    }
    const resetFleet= () => {
        setFleetSelected(null);
        applyFilter();
    }

    /* Application des filtres */
    const applyFilter = (filterId = null, vin = null, fleet = null) => {
        let queryParams = '';

        if (filterId) {
            if (queryParams.length > 0) {
                queryParams += '&';
            }
            queryParams += `filter_id=${filterId}`;
        }

        if (vin) {
            if (queryParams.length > 0) {
                queryParams += '&';
            }
            if (Array.isArray(vin)) {                
                queryParams += `${vin.map(v => `vin=${encodeURIComponent(v)}`).join('&')}`
            } else {
                queryParams += `vin=${vin}`;
            }            
        }

        if (fleet) {
            if (queryParams.length > 0) {
                queryParams += '&';
            }
            queryParams += `metropolis=${fleet}`;
        }

        if (queryParams.length > 0) {
            queryParams += '&last_event=1'
            dispatch(eventsActions.getFiltered(queryParams));
            dispatch(mapActions.getLastPositions(queryParams));
        } else {
            dispatch(eventsActions.getLastEvents());
            dispatch(mapActions.getLastPositions());
        }
    };

    /* Gestion de l'autorefresh et de l'état des filtre et checkbox*/
    const handleToogleAutoRefresh = (value) => {
        dispatch(eventsActions.toggleAutoRefresh(value));
    }  

    useEffect(() => {
        // Nettoie l'intervalle à chaque fois que le composant est démonté
        return () => {
            if (intervalId) {
                dispatch(eventsActions.toggleAutoRefresh(false));
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [intervalId]);

    useEffect(() => {
        if (autoRefresh) {
            const id = setInterval(() => {
                applyFilter(filterSelected);
                dispatch(mapActions.getLastPositions());
            }, 120000); // 120 secondes
            setIntervalId(id);
        } else {
            // Si autoRefresh est désactivé, nettoie l'intervalle
            if (intervalId) {
                dispatch(eventsActions.toggleAutoRefresh(false));
                clearInterval(intervalId);
                setIntervalId(null);
            }
        }        
        // Nettoyage sur le changement de busVin ou autoRefresh
        return () => {
            if (intervalId) {
                dispatch(eventsActions.toggleAutoRefresh(false));
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [autoRefresh, filterSelected, dispatch]); 

    return (
        <div className='settings-content overflow-auto'>         
            {/* RAFRAICHISSEMENT */}
            <div className="settings-title">
                <span>RAFRAICHISSEMENT</span>
            </div>
            <div className="settings-info">Si activé les données sont rafraichies <br/>automatiquement toutes les 2 minutes</div>
            <div className="settings-selection">
                <AutoRefreshToogle action={handleToogleAutoRefresh}/>
            </div>
            {/* RECHERCHE */}
            <div className="settings-title">
                <span>RECHERCHER</span>
            </div>
            <div className="settings-selection">    
                {/*<CustomAutocomplete             
                    name="vin"
                    label="Sélectionnez un VIN"
                    options={vinList}
                    noOptionsText="Aucune correspondance"
                    onChange={handleVINChange}
                    onInputChange={() => false}
                    onClear={resetVin}
                    value={vinSelected}
                />*/}      
                <MultiSelectAutocomplete       
                    name="vin"
                    label="Sélectionnez un ou plusieurs VIN"
                    options={vinList}                      
                    value={vinSelected}
                    onChange={handleVINChange}
                    onClear={resetVin}
                    onInputChange={() => false}                                                           
                />   
                <button className="btn btn-custom btn-custom-primary float-right mt-2" onClick={() => handleVinSearch()}>
                    <img src={getIcons('searchOutlined')} alt='add icon' className='btn-custom-icon'/>
                    RECHERCHER
                </button>        
            </div>
            <div className="settings-selection">    
                <CustomAutocomplete              
                    name="fleet"
                    label="Sélectionnez une flotte"
                    options={fleetList}
                    noOptionsText="Aucune correspondance"
                    onChange={handleFleetChange}
                    onInputChange={() => false}
                    onClear={resetFleet}
                    value={fleetSelected || null}
                />                 
            </div>
            {/* FILTRES */}
            <div className="settings-title">
                <span>FILTRER</span>
            </div>
            <div className="settings-selection">    
                <CustomAutocomplete          
                    name="filters"
                    label="Sélectionnez un filtre"
                    options={filterOptions}
                    noOptionsText="Aucune correspondance"
                    onChange={handleFilterChange}
                    onInputChange={() => false}
                    onClear={resetFilter}
                    //value={filterSelected}
                />                 
            </div>
            <div className="settings-selection">
                <button className="btn btn-custom btn-custom-primary m-auto" onClick={() => navigate('/filtres/add')}>
                    <img src={getIcons('addOutlined')} alt='add icon' className='btn-custom-icon'/>
                    CRÉER UN FILTRE
                </button>
            </div>
            {/* CHECKBOXES */}
            <div className="settings-title mt-4">
                <span>AFFICHER</span>
            </div>
            <div className="flex flex-col">
                {layersList.map((subSection, idx) => (
                    <div key={idx} style={{ marginTop: '10px' }}>
                        <div className="settings-title-md">{subSection.subTitle}</div>
                        <div className="flex flex-col">
                            {subSection.layers.map((layer, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            checked={layerVisibility[layer.id] || false}
                                            onChange={() => handleLayerVisibilityChange(layer.id)}
                                            name={layer.label}
                                        />
                                    }
                                    label={layer.label}
                                />
                            ))}
                        </div>                        
                    </div>
                ))}
            </div>

        </div>
    )
}
